import React from 'react';

import PropTypes from 'prop-types';

const RewardedReviewerIcon = ({
  color = 'currentColor',
  size = '1em',
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <rect
        width="14.35"
        height="14.35"
        transform="translate(0 0.149902)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75088 9.80204L3.53223 5.68627L5.73154 6.72851L7.21979 3.24829L8.70802 6.72851L10.9073 5.68627L9.68868 9.80204H4.75088Z"
        fill={color}
        stroke={color}
        strokeWidth="0.711881"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.21929 3.09331C7.46553 3.09331 7.66515 2.89371 7.66515 2.64748C7.66515 2.40126 7.46553 2.20166 7.21929 2.20166C6.97305 2.20166 6.77344 2.40126 6.77344 2.64748C6.77344 2.89371 6.97305 3.09331 7.21929 3.09331Z"
        fill={color}
        stroke={color}
        strokeWidth="0.71198"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3169 5.57866C11.5632 5.57866 11.7628 5.37906 11.7628 5.13284C11.7628 4.88662 11.5632 4.68701 11.3169 4.68701C11.0707 4.68701 10.8711 4.88662 10.8711 5.13284C10.8711 5.37906 11.0707 5.57866 11.3169 5.57866Z"
        fill={color}
        stroke={color}
        strokeWidth="0.71198"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.04839 5.57866C3.29463 5.57866 3.49425 5.37906 3.49425 5.13284C3.49425 4.88662 3.29463 4.68701 3.04839 4.68701C2.80215 4.68701 2.60254 4.88662 2.60254 5.13284C2.60254 5.37906 2.80215 5.57866 3.04839 5.57866Z"
        fill={color}
        stroke={color}
        strokeWidth="0.71198"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

RewardedReviewerIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default RewardedReviewerIcon;
